import { log } from '../utils/logger.ts';

export function setupGPUErrorHandling(device: GPUDevice): void {
  device.addEventListener('uncapturederror', (event) => {
    log.error('Uncaptured GPU error:', (event as GPUUncapturedErrorEvent).error.message);
  });

  device.lost.then((info) => {
    log.error('GPU device lost:', info.message);
    if (info.reason !== 'destroyed') {
      log.error('Unexpected device loss — reload the page to recover.');
    }
  });
}
